import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#000000' cx='12' cy='12' r='12' />,
    <circle key='1' fill='#FFFFFF' cx='12' cy='12' r='10' />,
    <path
      key='2'
      fill='#000000'
      d='M5.1,5.7c-0.4,0.4-0.4,0.8,0,1.1l1,1c-1,1.3-1.5,2.8-1.5,4.5c0,2.4,1.2,4.6,3,6c0.4,0.3,0.9,0.2,1.1-0.3
	c0.2-0.4,0.1-0.7-0.2-1C7,15.9,6,14.2,6,12.2c0-1.3,0.5-2.5,1.2-3.5l1.1,1.1c-0.5,0.7-0.7,1.5-0.7,2.4c0,1.4,0.6,2.5,1.5,3.3
	c0.4,0.3,0.9,0.2,1.1-0.2l0,0c0.2-0.3,0.1-0.7-0.2-0.9c-0.6-0.5-1-1.4-1-2.2c0-0.5,0.1-0.9,0.4-1.4l1.2,1.2v0.2
	c0,0.8,0.6,1.4,1.4,1.4h0.2l5.1,5.1c0.3,0.3,0.7,0.3,1.1,0c0.3-0.3,0.3-0.7,0-1.1L6.1,5.7C5.8,5.4,5.4,5.4,5.1,5.7z M16.2,13.8
	c0.1-0.5,0.2-0.9,0.2-1.4c0-2.4-2-4.4-4.4-4.4c-0.5,0-0.9,0.1-1.4,0.2l1.3,1.3c0,0,0,0,0.1,0c1.6,0,3,1.4,3,3v0.1L16.2,13.8z
	 M12,6.4c3.3,0,6,2.6,6,6c0,0.9-0.2,1.7-0.5,2.5l1.1,1.1c0.6-1.1,1-2.3,1-3.6C19.5,8.3,16.1,5,12,5c-1.3,0-2.5,0.4-3.6,1l1.1,1.1
	C10.2,6.6,11.1,6.4,12,6.4z'
    />,
  ],
  'TransportConditionSignalOff'
);

const TransportConditionSignalOffIcon = function (props) {
  return (
    <SvgIcon
      className=''
      sx={(theme) => ({
        'circle:first-of-type': {
          fill: theme.palette[props.color ? props.color : 'error'].main,
        },
      })}
      {...props}
    />
  );
};

export default memo(TransportConditionSignalOffIcon);
